import React from 'react'

function Feedback() {
  return (
    <div className="feedback-section">
    <div className="flex">
      <div className="feedback-img">
        <img src="https://kanmanimotobikes.com/public/assets/img/img-reviews.png" alt="img" />
      </div>
      <div className="feedback-content">
        <h2>WHAT CUSTOMERS SAYS</h2>
<div className="slide">
<p>Recently took the delivery of FZ-X the staff behaviour is really polite. The follow up is also good even after delivery. Show room is well planned for vehicle display.</p>
        <div className="flex no-wrap ">
          <img src="https://kanmanimotobikes.com/public/assets/img/testimonial/testimonial3.png" alt="img" />
          <p>DINESHKUMAR R</p>
        </div>
</div>

      </div>
    </div>
  </div>
);
}


export default Feedback